export const staticMessagesError = {
    ADD_DETAIL: "Erro ao adicionar variação do produto.",
    UPLOAD_IMAGE: "Falha ao enviar imagem. Tente outra imagem ou contate o suporte.",
    EDIT_DETAIL: "Erro ao editar variação do produto.",
    CREATE_GROUP_PRODUCT: "Erro ao criar grupo de produtos."
}